module.exports = __webpack_public_path__ + "static/lososova-51c51a7eac919ebcd7b8b4067f005120.jpg";